import React from "react";

export default function Header() {
  return (
    <header>
      <h3 style={{ color: "#458478" }}>hopon.vc</h3>
    </header>
  );
}
